// extracted by mini-css-extract-plugin
export default {"section":"OurStory_section__1rpOh","inner":"OurStory_inner__bh5FF","label":"OurStory_label__xQu+w","body":"OurStory_body__orHxh"};